import React from 'react';
import { motion } from 'framer-motion';
import { UserRound, FileText, Mail, ArrowRight } from 'lucide-react';
const steps = [{
  number: 1,
  icon: UserRound,
  title: 'Cuéntanos tu historia',
  description: 'Agenda una sesión con nosotros para que podamos conversar y nos cuentes sobre tu caso, cuáles son tus metas y qué quieres lograr.'
}, {
  number: 2,
  icon: FileText,
  title: 'Analizamos tu reporte de crédito',
  description: 'Un especialista revisará tu reporte de crédito para identificar errores, inexactitudes y reportes injustos, y te ofrecerá una estrategia personalizada que se ajuste a tu caso.'
}, {
  number: 3,
  icon: Mail,
  title: 'Nosotros luchamos por ti',
  description: 'Este es un proceso completamente DFY (Done For You): será nuestro equipo quien dispute las cuentas por ti. Te mantendremos informado y actualizado sobre cada avance en todas las etapas del proceso.'
}];
export function Process() {
  return <section id="proceso" className="py-20 md:py-24 bg-black px-4 sm:px-6 lg:px-8 border-t border-white/5 relative overflow-hidden" data-id="element-189" data-mp="19lr5r9bwsoqv">
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-190" data-mp="15lqpdj5923h6">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-14 md:mb-16" data-id="element-191" data-mp="10s4d3s3001lw">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-192" data-mp="huusw8pumk3l">
            Nuestro Proceso
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-193" data-mp="2c7b29idxyeco">
            ¿Cómo{' '}
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-194" data-mp="2qdmkljl38evu">
              transformamos
            </span>{' '}
            tu crédito?
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-195" data-mp="2hdpowy0a6fra">
            Un proceso probado, diseñado para transformar tu crédito y
            desbloquear financiamiento.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-16" data-id="element-196" data-mp="3a23qtouhpw84">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          delay: index * 0.12,
          ease: [0.16, 1, 0.3, 1]
        }} className={`relative flex flex-col items-center text-center p-8 rounded-3xl bg-gradient-to-b from-white/[0.04] to-white/[0.01] border transition-all duration-500 ${step.number === 2 ? 'border-amber-500/40 shadow-lg shadow-amber-500/10' : 'border-white/[0.08] hover:border-amber-500/20'}`} data-id="element-197" data-mp="3e130tnv2wj6f" data-mpi={index}>
              {/* Icon tile with number badge */}
              <div className="relative mb-8" data-id="element-198" data-mp="12gvfpzajyb2j">
                <div className="h-20 w-20 rounded-2xl bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 flex items-center justify-center shadow-lg shadow-amber-500/30" data-id="element-199" data-mp="12dhcypxz7zuk">
                  <step.icon className="h-9 w-9 text-black" strokeWidth={2} data-id="element-200" data-mp="1c6y6rty45ey8" />
                </div>
                <div className="absolute -top-2 -right-2 h-7 w-7 rounded-full bg-black border border-amber-500/40 flex items-center justify-center" data-id="element-201" data-mp="17dlvelig34nf">
                  <span className="text-xs font-bold bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent" data-id="element-202" data-mp="eqsrju9rdp97">
                    {step.number}
                  </span>
                </div>
              </div>

              <h3 className="text-xl font-bold text-white mb-4" data-id="element-203" data-mp="xcup83rcf83e">
                {step.title}
              </h3>
              <p className="text-white/50 font-light leading-relaxed text-[15px]" data-id="element-204" data-mp="129kzgaggv9gw">
                {step.description}
              </p>
            </motion.div>)}
        </div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex justify-center" data-id="element-205" data-mp="1b5kb886vgd0i">
          <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 hover:brightness-110 text-black font-semibold px-10 py-4 rounded-full transition-all text-base shadow-2xl shadow-amber-500/30" data-id="element-206" data-mp="3rrlezsjqil37">
            Comienza tu proceso ahora
            <ArrowRight className="h-4 w-4" data-id="element-207" data-mp="1v75d91e75pl4" />
          </a>
        </motion.div>
      </div>
    </section>;
}